module.exports = __webpack_public_path__ + "img/about-1.6e741849.jpg";